import React from "react";
import { renderToString } from "react-dom/server";
import productApi from "../../../api/product/productApi";

let products = [];
const getProduct = () => {
  const params = {
    published: true,
    page: 1,
    limit: 10000,
  };
  productApi.getProducts(params).then((res) => {
    if (res) {
      const data = res?.results.map((item) => {
        return { text: item.name, value: item.id };
      });
      products = data;
    }
  });
};

// import Product from "./product";
const View = (props) => {
  return (
    <>
      <div>
      <product id={props.id.type}>
        <iframe
          className="iframe-product"
          style={{
            width: "550px",
            height: "170px",
            border: "none !important",
          }}
          src={`/product-iframe/${props.id.type}`}
        ></iframe>
      </product>
      </div>
      <p></p>
    </>
  );
};

const plugin = function (editor) {
  var _dialog = false;

  var _typeOptions = [];

  function _getDialogConfig() {
    return {
      title: "Chọn sản phẩm",
      body: {
        type: "panel",
        items: [
          {
            type: "selectbox",
            name: "type",
            label: "Sản phẩm",
            items: _typeOptions,
            flex: true,
          },
        ],
      },
      onSubmit: function (api) {
        const id = api.getData();
        const html = renderToString(<View id={id} />);
        editor.insertContent(html);
        api.close();
      },
      buttons: [
        {
          text: "Close",
          type: "cancel",
          onclick: "close",
        },
        {
          text: "Insert",
          type: "submit",
          primary: true,
          enabled: true,
        },
      ],
    };
  }

  function _onAction() {
    _dialog = editor.windowManager.open(_getDialogConfig());

    _dialog.block("Loading...");

    getProduct();

    setTimeout(function () {
      _typeOptions = products;

      _dialog.redial(_getDialogConfig());

      _dialog.unblock();
    }, 1000);
  }

  editor.ui.registry.addButton("productButton", {
    text: "Chọn sản phẩm",
    icon: "temporary-placeholder",
    onAction: _onAction,
  });

  return {
    getMetadata: function () {
      return {
        name: "Select Product",
      };
    },
  };
};

export default plugin;
